import { render } from "./ChooseToCreate.vue?vue&type=template&id=76963e6e&scoped=true"
import script from "./ChooseToCreate.vue?vue&type=script&lang=js"
export * from "./ChooseToCreate.vue?vue&type=script&lang=js"

import "./ChooseToCreate.vue?vue&type=style&index=0&id=76963e6e&scoped=true&lang=scss"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76963e6e"]])

export default __exports__